import { EZModule } from "../../classes/v2/EZModule";
import 'swiper/css/bundle'; // import styles bundle
import SwiperElement from "./SwiperElement";

declare let ezentrum_session_vars : any;

export default class SwiperExt extends EZModule {
    // Saving all the swipers inside this array
    private swiperElementsArray: Array<SwiperElement> = [];
    private swiperMainImageIndex : number = -1;
    private swiperGalleryIndex : number = -1;

    /** @param configuration = part of the yaml with Swiper */
    constructor(configuration: any) { super(configuration); }

    public init(): void {
        // Collecting all the swiper elements
        let swiperArray:HTMLCollectionOf<HTMLDivElement> = document.getElementsByClassName('swiper') as HTMLCollectionOf<HTMLDivElement>;
        // Going over all items
        // Creating an instance with all properties

        for (let i = 0; i < swiperArray.length; i++)
        {
            let currentSwiper:SwiperElement = new SwiperElement();

            // Getting the current swipers specific classname, which we set beforehand as the !second! classname
            let newSwiperInitName: string = swiperArray[i].classList[1]; // current swiper

            // Getting the dataset with all setup configurations of the current identified swiper html element
            let swiperDataListArray:DOMStringMap = swiperArray[i].dataset; // getting the parameters as string

            // Reminder: key identifies the setup-parameter for the swiper object,  swiperDataListArray[key]  is the corresponding value
            // Looping over all data attributes and init the swiper object
            for (let key in swiperDataListArray) {
                // We handle only predefined properties, for now
                // Making sure we have it on our object
                if (currentSwiper.hasOwnProperty(key)) {
                    // Switch case for our properties
                    /** Different handling for various types
                         *  strings: simply overrides,
                         *  bool: to boolean
                         *  numbers: to numbers
                         *  objects: special methods to define their behavior
                         *  arrays: not yet implemented, it's not in use by swiper yet
                    */
                    switch(key) {
                        case "allowSlideNext": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "allowSlidePrev": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "autoHeight": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "slidesPerView":currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "slidesPerGroup":currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "loopFillGroupWithBlank": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "spaceBetween": currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "loop": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "speed": currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "centeredSlides": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "longSwipes": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "width": currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "pagination": currentSwiper[key] = this.setPagination( swiperDataListArray[key] ); break;
                        case "navigation": currentSwiper[key] = this.setNavigation( swiperDataListArray[key] ); break;
                        case "breakpoints": currentSwiper[key] = this.setBreakPoints( swiperDataListArray[key], swiperArray[i] ); break;
                        case "autoplay": currentSwiper[key] = this.setAutoPlay( swiperDataListArray[key] ); break;
                        case "freeMode": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "watchSlidesProgress": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false; break;
                        case "loopedSlides": currentSwiper[key] = Number( swiperDataListArray[key] ); break;
                        case "zoom": swiperDataListArray[key] === "true" ? currentSwiper[key] = true : currentSwiper[key] = false;  currentSwiper.addModule('Zoom'); break;
                        case "direction" : if (swiperDataListArray[key] === 'vertical' ) currentSwiper[key] = 'vertical'; break; // either horizontal (default) or vertical
                    }
                }
            }

            switch( newSwiperInitName ) {
                case 'swiperGallery': {
                    this.swiperGalleryIndex = i;

                    currentSwiper.addModule('FreeMode'); // adding freeMode Swiper Module
                    currentSwiper.addModule('Thumbs'); // adding Thumbs Swiper Module
                    currentSwiper.createSwiper(newSwiperInitName, currentSwiper); // creating the swiper

                    if ( this.swiperMainImageIndex > -1 ) {
                        const mainImageSwiper = this.swiperElementsArray[ this.swiperMainImageIndex ];
                        mainImageSwiper.thumbs = this.setThumbs(currentSwiper.swiperObj); // setting the thumb up with currentSwiper
                        mainImageSwiper.addModule('Thumbs'); // adding Thumbs Swiper Module
                        mainImageSwiper.createSwiper('swiperMainImage', mainImageSwiper); // creating previous swiper
                    }

                    if (ezentrum_session_vars.required.mandant_id === "201") {
                        window.addEventListener("resize", this.handleResize.bind(this));
                        currentSwiper.swiperObj.changeDirection(window.innerWidth >= 768 ? 'vertical' : 'horizontal', true);
                    }
                    break;
                }
                case 'swiperMainImage':
                    if (this.swiperGalleryIndex > -1 && this.swiperMainImageIndex === -1 ) {
                        currentSwiper.thumbs = this.setThumbs(this.swiperElementsArray[this.swiperGalleryIndex].swiperObj); // setting the thumb up with currentSwiper
                        currentSwiper.addModule('Thumbs'); // adding Thumbs Swiper Module
                        currentSwiper.createSwiper('swiperMainImage', currentSwiper); // creating previous swiper
                    }
                    if ( this.swiperMainImageIndex === -1 ) {
                        this.swiperMainImageIndex = i;
                    }
                    break;
                ;
                default: {
                    currentSwiper.createSwiper(newSwiperInitName, currentSwiper);
                    break;
                }
            }
            this.swiperElementsArray.push(currentSwiper); // pushing the complete swiper onto our swiperArray
        }
        console.log(this.swiperElementsArray); // logging the swipers
    }
    // Für Supplementa
    private handleResize() {
        this.swiperElementsArray[this.swiperGalleryIndex].swiperObj.changeDirection(window.innerWidth >= 768 ? 'vertical' : 'horizontal', true);
    }

    /**
     * @description Setting the behavior for the navigation with predefined 'modes'
     * @param variation String from a data attribute
     * @returns Object | false
     */
    private setNavigation(variation:string): Object | false {
        if (variation === null) { return false;}
        let navigationObj:any = {}; // return variable
        switch (variation) {
            case "0": navigationObj = false; break;
            case "1":
                navigationObj.nextEl = ".swiper-button-next";
                navigationObj.prevEl = ".swiper-button-prev";
                break;
            case "2":
                navigationObj.nextEl = ".ez_swiper_next_btn";
                navigationObj.prevEl = ".ez_swiper_prev_btn";
                break;
            default:
                navigationObj.nextEl = ".swiper-button-next";
                navigationObj.prevEl = ".swiper-button-prev";
                break;
        }
        return navigationObj;
    }

    /**
     * @description Setting the behavior for the pagination with predefined 'modes'
     * @param variation String from a data attribute
     * @returns Object | false
     */
    private setPagination(variation:string): Object | false {
        if (variation === null) { return false; }
        let paginationObj: any = {}; // return variable
        switch (variation) {
            case "0": paginationObj = false; break;
            case "1":
                paginationObj.el = ".swiper-pagination";
                paginationObj.type = "bullets";
                paginationObj.clickable = true;
                paginationObj.dynamicBullets = true;
                break;
            case "2":
                paginationObj.el = ".swiper-pagination";
                paginationObj.type = "fraction";
                paginationObj.clickable = true;
                paginationObj.dynamicBullets = true;
                break;
            case "3":
                paginationObj.el = ".swiper-pagination";
                paginationObj.type = "progressbar";
                paginationObj.clickable = true;
                paginationObj.dynamicBullets = true;
                break;
            default:
                paginationObj.el = ".swiper-pagination";
                paginationObj.type = "bullets";
                paginationObj.clickable = true;
                paginationObj.dynamicBullets = true;
                break;
        }
        return paginationObj;
    }

    /**
     * @description Setting the behavior for the breakpoints with predefined 'modes'
     * @param variation String from a data attribute
     * @param currentSwiper the currently configured swiper
     * @returns Object | false
     */
    private setBreakPoints(variation:string, currentSwiper:HTMLDivElement): Object | false {
        if (variation === null) { return false; }
        let breakpointsObj: Object | false = {}; // return variable
        // getting the amount of items that can be displayed, using this value for differently displaying the items if there are not enough (numberwise)
        let currentSuchAnzahl: string;

        // making sure there is a standard value set
        currentSuchAnzahl = currentSwiper.getAttribute('value') || "4";

        switch(variation) {
            case "0":
                breakpointsObj =  {
                    // seens as >= {number}
                    1: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        slidesPerGroup: 1
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        slidesPerGroup: 2
                    },
                    700: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        slidesPerGroup: 3
                    },
                    1250: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                        slidesPerGroup: 4
                    }
                }
                break;
            case "1":
                switch(currentSuchAnzahl) {
                    case "1":
                        breakpointsObj = {
                            // seens as >= {number}
                            1: {
                                slidesPerView: 1,
                                slidesPerGroup: 1
                            }
                        }
                        break;
                    case "2":
                        breakpointsObj = {
                            1: {
                                slidesPerView: 1,
                                slidesPerGroup: 1
                            },
                            1200: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                            }
                        }
                        break;
                    case "3":
                        breakpointsObj = {
                            1: {
                                slidesPerView: 1,
                                slidesPerGroup: 1
                            },
                            1200: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                            },
                            1500: {
                                slidesPerView: 3,
                                slidesPerGroup: 3
                            }
                        };break;
                    /**
                     *  * making the swiper breakpoints individually handlebar, json is written inside the html.
                         *  e.g.'{
                                "1": {
                                    "slidesPerView": 1,
                                    "slidesPerGroup": 1
                                },
                                "630": {
                                    "slidesPerView": 2,
                                    "slidesPerGroup": 1
                                },
                                "768": {
                                    "slidesPerView": 3,
                                    "slidesPerGroup": 1
                                },
                                "990": {
                                    "slidesPerView": 4,
                                    "slidesPerGroup": 1
                                }
                            }'
                     */
                    case 'individual': {
                        try {
                            breakpointsObj = JSON.parse(currentSwiper.getAttribute('data-breaks'));
                        }
                        catch(err) {
                            breakpointsObj = false;
                        }
                        break;
                    }
                    default:
                        breakpointsObj = {
                            1: {
                                slidesPerView: 1,
                                slidesPerGroup: 1
                            },
                            1200: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                            },
                            1500: {
                                slidesPerView: 3,
                                slidesPerGroup: 3
                            },
                            2000: {
                                slidesPerView: 4,
                                slidesPerGroup: 4
                            }
                        }; break;
                }
                break;
            default: breakpointsObj = false; break;
        }
        return breakpointsObj;
    }

    /**
     * @description Setting the behavior for the autoplay with predefined 'modes'
     * @param variation String from a data attribute
     * @returns Object | false
     */
    private setAutoPlay(variation:string): Object | false {
        if (variation === null) { return false;}
        let autoplayObj: Object | false = {}; // return variable
        switch(variation) {
            case "0": autoplayObj = false; break;
            case "1":
                autoplayObj = {
                    delay: 5000,
                    disableOnInteraction: false,
                }
                break;
            case "2":
                autoplayObj = {
                    delay: 5000,
                    disableOnInteraction: true,
                }
                break;
            default: autoplayObj = false; break;
        }
        return autoplayObj;
    }

    /**
     * @description adding the gallery (article_direct) as thumbs to the main picture of the site
     * @param swiperGallery = currentSwiper / .swiperGallery
     * @returns thumbs
     */
    private setThumbs(swiperGallery:Object): Object | false {
        if (swiperGallery === null) { return false; }
        if (swiperGallery === '') { return Error('In SwiperExt, the string for the setThumbs method has not been set.');}
        let thumbsObj: Object | false = {}; // return variable
        return thumbsObj = {
            swiper : swiperGallery
        };
    }

    /** Runs the module. */
    public run(): void {} // empty. Kept for compability.
}